import type { TrigKey } from './keys';

export const ja: Partial<Record<TrigKey, string>> = {
  'app.eyebrow': '数学 · 三角法',
  'panel.experiment': '実験',
  'panel.params': 'パラメータ',
  'panel.scene': '実験を選ぶ',
  'experiment.right-triangle.label': '直角三角形',
  'experiment.unit-circle.label': '単位円',
  'experiment.wave-studio.label': '波スタジオ',
  'experiment.identity-playground.label': '恒等式',
  'experiment.triangle-solver.label': '三角形ソルバー',
  'experiment.circular-polar.label': '円運動・極座標',
  'hint.line1': '点をドラッグし、スライダーを動かす。',
  'hint.line2': '教材は幾何そのものに宿る、文章ではない。',
  'rt.angle.a': '角 A',
  'rt.angle.b': '角 B',
  'rt.angle.value': '∠',
  'rt.units.rad': 'ラジアン',
  'rt.show.sin': 'sin',
  'rt.show.cos': 'cos',
  'rt.show.tan': 'tan',
  'rt.snap': '30°/45°/60° にスナップ',
  'uc.units': '単位',
  'uc.show.sin': 'sin',
  'uc.show.cos': 'cos',
  'uc.show.tan': 'tan',
  'uc.show.csc': 'csc',
  'uc.show.sec': 'sec',
  'uc.show.cot': 'cot',
  'uc.show.astc': 'ASTC を表示',
  'uc.snap.common': 'よく使う角にスナップ',
  'uc.angle.value': '∠',
  'uc.units.deg': '度',
  'uc.units.rad': 'rad',
  'uc.units.both': '度+rad',
  'ws.fn': '関数',
  'ws.fn.sin': 'sin',
  'ws.fn.cos': 'cos',
  'ws.fn.tan': 'tan',
  'ws.fn.csc': 'csc',
  'ws.fn.sec': 'sec',
  'ws.fn.cot': 'cot',
  'ws.amplitude': 'A — 振幅',
  'ws.frequency': 'B — 周波数',
  'ws.phase': 'C — 位相ずれ',
  'ws.shift': 'D — 垂直移動',
  'ws.rform.toggle': 'R 形式の導出',
  'ws.rform.a': 'a (sin 係数)',
  'ws.rform.b': 'b (cos 係数)',
  'ws.rform.r': 'R',
  'ws.rform.alpha': 'α',
  'ws.reset': 'リセット',
  'ws.base': '基本曲線を表示',
  'ip.id.pythagorean': 'ピタゴラス',
  'ip.id.reciprocal': '逆数',
  'ip.id.quotient': '商',
  'ip.id.sum': '和',
  'ip.id.difference': '差',
  'ip.id.double': '倍角',
  'ip.id.half': '半角',
  'ip.play': '再生',
  'ip.pause': '一時停止',
  'ip.step': 'ステップ',
  'ip.reset': 'リセット',
  'ip.proof.pythagorean.summary': 'sin²θ + cos²θ = 1',
  'ip.proof.reciprocal.summary': 'csc θ = 1/sin θ,  sec θ = 1/cos θ,  cot θ = 1/tan θ',
  'ip.proof.quotient.summary': 'tan θ = sin θ / cos θ',
  'ip.proof.sum.summary': 'sin(A+B) = sin A cos B + cos A sin B',
  'ip.proof.difference.summary': 'sin(A−B) = sin A cos B − cos A sin B',
  'ip.proof.double.summary': 'sin 2θ = 2 sin θ cos θ',
  'ip.proof.half.summary': 'sin(θ/2) = ±√((1 − cos θ)/2)',
  'ip.proof.v2.note': 'v2 で実装予定 — この証明はより本格的な構成が必要です。',
  'ts.area': '面積',
  'ts.sineRule': '正弦定理',
  'ts.cosineRule': '余弦定理',
  'ts.ambiguous.toggle': '曖昧な場合に幽霊三角を表示',
  'ts.reset': '正三角形にリセット',
  'ts.snap.integers': '整数にスナップ',
  'ts.side.a': 'a',
  'ts.side.b': 'b',
  'ts.side.c': 'c',
  'ts.angle.A': 'A',
  'ts.angle.B': 'B',
  'ts.angle.C': 'C',
  'ts.section.sides': '辺',
  'ts.section.angles': '角',
  'ts.section.sineRule': '正弦定理',
  'ts.section.cosineRule': '余弦定理',
  'ts.section.area': '面積',
  'cp.omega': '角速度',
  'cp.plot.y': 'y を描画 (sin)',
  'cp.plot.x': 'x を描画 (cos)',
  'cp.polar.label': '極座標図',
  'cp.polar.circle': '円 (r = 1)',
  'cp.polar.rose': 'バラ (r = sin 3θ)',
  'cp.polar.cardioid': 'カージオイド (r = 1 + cos θ)',
  'cp.polar.limacon': 'リマソン (r = 1 − 2 cos θ)',
  'cp.smallAngle': '微小角近似 (sin x ≈ x)',
  'cp.play': '再生',
  'cp.pause': '一時停止',
  'cp.reset': 'リセット',
  'cp.step': 'ステップ π/12',
};
